import GolfList from './GolfList';

export default GolfList;
